import styled from 'styled-components'

export const StyledImage = styled.img`
  object-fit: contain;
`
export const ImageBox = styled.div`
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  width: 150px;
`
